import type {ReactElement} from 'react';
import React from 'react';
import {Text, TextSize} from '@Components/text';
import {CircularProgressLoader, LOADER_COLOR, LOADER_SIZE} from '@Components/circular-progress-loader';
import styles from './notification.module.scss';

interface NotificationProps {
  text: string;
  showLoading?: boolean;
  className?: string;
  isRound?: boolean;
  onMouseEnter?: React.MouseEventHandler<HTMLDivElement>;
  onMouseLeave?: React.MouseEventHandler<HTMLDivElement>;
}

export function Notification({
  className = '',
  showLoading = false,
  isRound = true,
  onMouseEnter = (): void => {},
  onMouseLeave = (): void => {},
  ...props
}: NotificationProps): ReactElement {
  return (
    <div
      className={`${styles.container} ${isRound ? 'radius-round' : ''} radius-round flex-center _fit-width ${className}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {showLoading ? (
        <CircularProgressLoader color={LOADER_COLOR.WHITE} size={LOADER_SIZE.XSMALL} classes="spacing-m-0" />
      ) : (
        <Text val={props.text} size={TextSize.XXSMALL} bold className="content-body-white" />
      )}
    </div>
  );
}
